import axios from 'axios';
import { getAuthStorage } from '../storage';

// API separada para o backend do ContaChat (WhatsApp)
const WHATSAPP_API_URL = process.env.REACT_APP_CONTACHAT_API_URL || 'http://localhost:8001';
export const WHATSAPP_BASE_URL = WHATSAPP_API_URL;

export const waApi = axios.create({
  baseURL: `${WHATSAPP_API_URL}/api/v1`,
  timeout: 30000,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Interceptor para adicionar token de auth do Indicadores
waApi.interceptors.request.use(async config => {
  const storageAuth = await getAuthStorage();
  if (storageAuth?.access_token) {
    // eslint-disable-next-line no-param-reassign
    config.headers.Authorization = `Bearer ${storageAuth.access_token}`;
  }
  return config;
});

export default waApi;
